import React from 'react';
import { Link } from 'react-router-dom';
import { mediaUrl } from '../../api/client';
import Image from '../common/Image';
import { NewsletterForm } from '../layout/Footer';

export function FeaturedCollections({ section }) {
  const d = section.data || {};
  const cols = section.collections || [];
  if (!cols.length) return null;
  return (
    <section className="sf__featured-collections">
      <div className="container-fluid section-my">
        {d.heading && <div className="section__header text-center"><h2 className="section__heading">{d.heading}</h2></div>}
        <div className={`grid grid-cols-2 md:grid-cols-${Math.min(cols.length, 4)} gap-4 md:gap-8`}>
          {cols.map((c) => (
            <Link key={c._id} to={`/collections/${c.slug}`} className="block text-center sf__hover-scale-up overflow-hidden">
              <Image src={c.image} alt={c.name} ratio={1} imgClassName="object-cover w-full h-full" />
              <h3 className="text-lg font-medium mt-4">{c.name}</h3>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export function ImageText({ section }) {
  const d = section.data || {};
  return (
    <section className="sf-custom sf__img-with-text">
      <div className="container-fluid section-my">
        <div className={`sf-custom__grid flex flex-wrap items-center -mx-4 ${d.reverse ? 'flex-row-reverse' : ''}`}>
          <div className="sf-custom__block sf-custom__block--image flex lg:w-1/2 w-full items-center px-4">
            <div className="sf-custom__block-inner w-full"><div className="sf__hover-scale-up overflow-hidden">{d.image && <img src={mediaUrl(d.image)} alt={d.heading || ''} className="w-full" loading="lazy" />}</div></div>
          </div>
          <div className="sf-custom__block sf-custom__block--text flex lg:w-1/2 w-full items-center px-4 mt-8 lg:mt-0">
            <div className="sf-custom__block-inner w-full">
              <div className={d.align === 'center' ? 'text-center' : 'text-left'}>
                {d.subheading && <p className="section__subheading">{d.subheading}</p>}
                {d.heading && <h2 className="text-3xl md:text-4xl mb-4">{d.heading}</h2>}
                <div className="prose rte mt-4 text-color-subtext" dangerouslySetInnerHTML={{ __html: d.text || '' }} />
                {d.buttonText && <Link to={d.link || '#'} className="sf__btn sf__btn-primary mt-6 inline-block">{d.buttonText}</Link>}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function CustomHtml({ section }) {
  const d = section.data || {};
  if (!d.html) return null;
  return (
    <section className="sf-custom-html">
      <div className={d.fullWidth ? '' : 'container-fluid section-my'} dangerouslySetInnerHTML={{ __html: d.html }} />
    </section>
  );
}

export function VideoSection({ section }) {
  const d = section.data || {};
  if (!d.url) return null;
  const yt = d.url.match(/(?:youtu\.be\/|v=)([\w-]+)/);
  return (
    <section className="sf-video">
      <div className="container-fluid section-my">
        {d.heading && <div className="section__header text-center"><h2 className="section__heading">{d.heading}</h2></div>}
        <div className="eg-video-wrap">
          {yt ? (
            <iframe src={`https://www.youtube.com/embed/${yt[1]}`} title={d.heading || 'Video'} allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen loading="lazy" />
          ) : (
            <video src={mediaUrl(d.url)} controls poster={mediaUrl(d.poster)} />
          )}
        </div>
      </div>
    </section>
  );
}

export function NewsletterSection({ section }) {
  const d = section.data || {};
  return (
    <section className="sf__newsletter-section" style={{ backgroundImage: d.image ? `url(${mediaUrl(d.image)})` : undefined, backgroundColor: d.background || '#f7f8fa', backgroundSize: 'cover' }}>
      <div className="container py-16 md:py-24 text-center max-w-2xl">
        <h2 className="text-3xl md:text-4xl mb-3">{d.heading || 'Subscribe to our newsletter'}</h2>
        <p className="text-color-secondary mb-6">{d.text || 'Be the first to know about new collections and product launches.'}</p>
        <NewsletterForm source="home" className="max-w-md mx-auto" />
      </div>
    </section>
  );
}
